import { z } from "zod";

export const verifyPhoneSchema = z.object({
  code: z.string().min(1, {
    message: "You need to enter a code.",
  }),
});

export type VerifyPhoneFormData = z.infer<typeof verifyPhoneSchema>;
